export default "__VITE_ASSET__Dih8vKKH__"